<!-- 查看核查商品标签 -->
<template>
    <div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">标签编码</div>
                <div class="search-item">
                    <el-input size="small" v-model.trim="searchData.LabelCode" placeholder="标签编码"></el-input>
                </div>
                <div class="search-name">汽配编码</div>
                <div class="search-item">
                    <el-input size="small" v-model.trim="searchData.APCode" placeholder="汽配编码"></el-input>
                </div>
                <div class="search-name">汽配名称</div>
                <div class="search-item">
                    <el-input size="small" v-model.trim="searchData.GoodName" placeholder="汽配名称"></el-input>
                </div>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                show-summary
                :summary-method="getSummaries"
                :data="tableData"
                border
                ref="multipleTable"
                max-height="470px"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column fixed show-overflow-tooltip width="180" prop="LabelCode" label="标签编码"></el-table-column>
                <el-table-column show-overflow-tooltip width="160" prop="APCode" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="180" prop="GoodName" label="配件名称"></el-table-column>
                <el-table-column show-overflow-tooltip width="70" prop="Unit" label="单位"></el-table-column>
                <el-table-column show-overflow-tooltip width="70" prop="PackingSpec" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="CostPrice" label="标签成本"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" label="标签总成本">
                    <template slot-scope="scope">
                        {{ (scope.row.PackingSpec * scope.row.CostPrice).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="120" prop="StorageName" label="存放仓库"></el-table-column>
                <el-table-column show-overflow-tooltip width="120" prop="SpaceName" label="存放仓位"></el-table-column>
                <el-table-column show-overflow-tooltip width="160" prop="CreateTime" label="创建时间"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.Page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.Limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: { OrderId: String },
    components: {},
    data() {
        return {
            loading: false,
            searchData: {
                OrderId: this.OrderId,
                LabelCode: '',
                APCode: '',
                GoodName: '',
                Page: 1,
                Limit: 10
            },
            tableDataLength: 0,
            tableData: []
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        resetSearch() {
            this.searchData.LabelCode = '';
            this.searchData.APCode = '';
            this.searchData.GoodName = '';
            this.searchData.Page = 1;
            this.searchData.Limit = 10;
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoodsLabels/GetTranOrderOutLabels',
                    data: this.searchData
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (column.property == 'PackingSpec' || column.property == 'CostPrice') {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        let strL = sums[index] + '';
                        if (strL.indexOf('.') > -1) {
                            let str = strL.split('.')[1];
                            if (str.length > 2) {
                                sums[index] = sums[index].toFixed(2);
                            }
                        }
                    } else {
                        sums[index] = '';
                    }
                } else if (column.label == '标签总成本') {
                    let totalAmount = 0;
                    if (data.length > 0)
                        for (let i = 0; i < data.length; i++) {
                            totalAmount += Number(data[i].PackingSpec * data[i].CostPrice);
                        }
                    sums[index] = totalAmount.toFixed(2);
                    return;
                } else {
                    sums[index] = '';
                    return;
                }
            });

            return sums;
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn-left {
    margin-bottom: 10px;

    .search-name {
        margin-bottom: 0;
    }
}
</style>
